import React, { useRef, useEffect } from "react";
import { useLanguage } from "../../context/LanguageContext";
import styles from "./index.module.css";

interface LanguageSwitcherProps {
  variant?: "secondary" | "tertiary";
  className?: string;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ variant = "secondary", className }) => {
  const { language, setLanguage } = useLanguage();

  // 🔹 Grab a ref to your custom element
  const toggleRef = useRef<any>(null);

  // derive from context
  const toggled = language === "ja";

  // 🔹 Sync React state -> custom element
  useEffect(() => {
    if (toggleRef.current) {
      toggleRef.current.toggle = toggled;
      toggleRef.current.setAttribute("aria-pressed", String(toggled));
    }
  }, [toggled]);

  const handleClick = () => {
    setLanguage(language === "en" ? "ja" : "en");
  };

  return (
    <mui-button class={`${styles.topMenu} ${className || ""}`} onClick={handleClick} variant={variant}>
      {/* {language === "en" ? "日本語" : "English"} */}

      <mui-icon-toggle rotate ref={toggleRef}>
        {/* Temporary solution for transaltions • Working File in Muibook Figma */}
        <mui-icon-translate slot="start"></mui-icon-translate>
        <mui-icon-translate flip slot="end"></mui-icon-translate>
      </mui-icon-toggle>
    </mui-button>
  );
};

export default LanguageSwitcher;
